const facebookLoadPixel = () => {
    const n = window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
};

const facebookAddToCart = ({ cartItems, addedItems }) => {
    const itemsList = [];

    addedItems.forEach(({ sku: addedSku, quantity }) => {
        const { product: { sku, name, price_range } } = cartItems.find(({ product: { sku } }) => sku === addedSku);

        itemsList.push({ sku, name, price_range, quantity });
    });

    itemsList.forEach(({
        sku,
        name,
        price_range: {
            minimum_price: {
                regular_price: { value, currency }
            }
        },
    }) => {
        window.fbq('track', 'AddToCart', {
            content_ids: [sku],
            content_type: 'product',
            content_name: name,
            value,
            currency,
        });
    });
};

const facebookPurchase = ({ total: { grand_total: { value, currency } } }) => {
    window.fbq('track', 'Purchase', { currency, value });
};

export {
    facebookLoadPixel,
    facebookAddToCart,
    facebookPurchase,
};
